// extracted by mini-css-extract-plugin
export default {"red":"red-MUUEbgQd","dropdownContainer":"dropdownContainer-bm__eHnb","settingsButton":"settingsButton-Do0xMYj1"};